const StudyinEnglish =() =>{
    return(
        <>
        <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10 text-center">
                    <h1 className="display-3 text-white animated slideInDown">Study in English</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center"><li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
Study in India
  </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

     <div className="container-xxl py-5">
        <div className="container">
            {/* <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3"></h6>
                <h1 className="mb-5">Study in English</h1>
            </div> */}
            
            {/* <div className="wow fadeInUp" data-wow-delay="0.2s">
    <div className="row">
        <div className="col-lg-12 wow fadeInUp" data-wow-delay="0.5s">
            <div className="card why-choose-card border-0 shadow h-100 p-4">

                <p className="mb-3">
                    Became a study in India is among the best options available for Arab students
                    for educational attainment and completion of studies and is due to several
                    reasons, which are fundamental axis basis in the decision-making process and
                    choose the appropriate country for the purpose of study and summarized these
                    reasons in the following:
                </p>

                <p className="mb-4">
                    1. Low cost of living and studying in the Republic of India is very significant.
                </p>
<p className="mb-4"> 2. Scientific and technological progress and economic reached by the Republic of India, who became a rival great powers</p>
                <div className="row align-items-start">
    
    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
        <p className="mb-4">
            3. Among one the most important reasons that make the student chooses to study in India
            is the use of the English language, both at the individual level or the government and
            are very common so almost become English native language in this country and is the use
            of English, even among members of the same family, in order to learn English available
            in the Republic of India best language institutes in the world, both in terms of cost
            or in terms of competence, where there are the best British teachers and at the lowest
            possible cost compare to Britain and the United States, Australia and everyone knows
            how much study is very expensive in these countries, where it is cost course language
            in the Republic of India and the best colleges and educational institutions for a
            period of 6 months does not exceed $1000 and the system used is a system Cambridge
            British and even teachers authorized by the British Consulate in order to teach English
            and certification by these institutes, some of the best language institutes in the
            Republic of India is MCM College, MCM College one of the best leading academies of
            English language learning and foreign languages in general.
        </p>

    </div>
    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
        <div className="card facility-card shadow">
            <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                 className="card-img-top facility-img"
                 alt="University Library" />
        </div>
    </div>
    <p className="mb-4">
4.Owning the largest network of educational institutions in the world and is characterized by high quality, discipline and worth almost reward value of educational institutions in Britain and this is normal because the education system in India is the British system    </p><p className="mb-4">
                5. India is among the major nuclear states
                </p>
    <p className="mb-4">
6. India because of its natural beauty and atmosphere is almost mild in most cases and in many Indian states</p>
    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
        <div className="card facility-card shadow">
            <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                 className="card-img-top facility-img"
                 alt="University Library" />
        </div>
    </div>
    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
        <p className="mb-4">Famed India in the field of industry information technology any (Information Technology) or (IT), where occupied India ranked first in the world in the production of software, and also in the field of telecommunications, where famed India industry and launch satellites, and are located in India Months headquarters software development in the world and one of them the headquarters of Microsoft Corp. U.S. and from which he graduated latest versions of Windows in the world, 70% of the number of programmers and experts informatics at Microsoft are Indians, and also excelled India in other sectors other as an industry automotive, electronics and electrical, machinery and leather industry and in many other fields.
        </p>
<p className="mb-4">Those interested in enrollment MCM please contact us at the following email address:
info@mcmcollege.com</p>
    </div>
</div>
</div>
        </div>
    </div>
</div> */}
 <div className="container-xxl py-5">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3"></h6>
                <h1 className="mb-5">Study in India</h1>
            </div>
            
            <div className="wow fadeInUp" data-wow-delay="0.2s">
    <div className="row">
        <div className="col-lg-12 wow fadeInUp" data-wow-delay="0.5s">
            <div className="card why-choose-card border-0 shadow h-100 p-4">

                <p className="mb-3">
                    Became a study in India is among the best options available for Arab students
                    for educational attainment and completion of studies and is due to several
                    reasons, which are fundamental axis basis in the decision-making process and
                    choose the appropriate country for the purpose of study and summarized these
                    reasons in the following:
                </p>

                <p className="mb-4">
                    1. Low cost of living and studying in the Republic of India is very significant.
                </p>
<p className="mb-4"> 2. Scientific and technological progress and economic reached by the Republic of India, who became a rival great powers</p>
                <div className="row align-items-start">
    
    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
        <p className="mb-4">
            3. Among one the most important reasons that make the student chooses to study in India
            is the use of the English language, both at the individual level or the government and
            are very common so almost become English native language in this country and is the use
            of English, even among members of the same family, in order to learn English available
            in the Republic of India best language institutes in the world, both in terms of cost
            or in terms of competence, where there are the best British teachers and at the lowest
            possible cost compare to Britain and the United States, Australia and everyone knows
            how much study is very expensive in these countries, where it is cost course language
            in the Republic of India and the best colleges and educational institutions for a
            period of 6 months does not exceed $1000 and the system used is a system Cambridge
            British and even teachers authorized by the British Consulate in order to teach English
            and certification by these institutes, some of the best language institutes in the
            Republic of India is MCM College, MCM College one of the best leading academies of
            English language learning and foreign languages in general.
        </p>

    </div>

    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
        <div className="card facility-card shadow">
            <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                 className="card-img-top facility-img"
                 alt="University Library" />
        </div>
    </div>
    <p className="mb-4">
4.Owning the largest network of educational institutions in the world and is characterized by high quality, discipline and worth almost reward value of educational institutions in Britain and this is normal because the education system in India is the British system    </p><p className="mb-4">
                5. India is among the major nuclear states
                </p>
    <p className="mb-4">
6. India because of its natural beauty and atmosphere is almost mild in most cases and in many Indian states</p>


    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
        <div className="card facility-card shadow">
            <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                 className="card-img-top facility-img"
                 alt="University Library" />
        </div>
    </div>
    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
        <p className="mb-4">Famed India in the field of industry information technology any (Information Technology) or (IT), where occupied India ranked first in the world in the production of software, and also in the field of telecommunications, where famed India industry and launch satellites, and are located in India Months headquarters software development in the world and one of them the headquarters of Microsoft Corp. U.S. and from which he graduated latest versions of Windows in the world, 70% of the number of programmers and experts informatics at Microsoft are Indians, and also excelled India in other sectors other as an industry automotive, electronics and electrical, machinery and leather industry and in many other fields.
        </p>
<p className="mb-4">Those interested in enrollment MCM please contact us at the following email address:
info@mcmcollege.com</p>
    </div>
</div>
</div>
        </div>
    </div>
</div>
        </div>
    </div>

            
            <div className="highlight-box text-center mt-4 wow fadeInUp" data-wow-delay="0.3s">
                <h3 className="text-white mb-3">Save 70-80% on Education Costs</h3>
                <p className="mb-0">Study in India and get world-class education at a fraction of Western costs</p>
            </div>
        </div>
    </div>
        </>
    )
}
export default StudyinEnglish;